import { useLayoutEffect as useLayoutEffect$1, useEffect } from 'react';

const useLayoutEffect = typeof window !== "undefined" ? useLayoutEffect$1 : useEffect;

export { useLayoutEffect };
//# sourceMappingURL=use-layout-effect.mjs.map
